export const CHAT_LIST_EMPTY_CONVERSATIONS_ACTION = 'emptyAllConversations';
export const CHAT_LIST_PAGE_RESET_ACTION = 'conversationPage/reset';
export const CHAT_LIST_CLEAR_CONVERSATION_CACHE_ACTION =
  'clearConversationCache';
export const CHAT_LIST_CLEAR_SELECTED_CONVERSATION_ACTION =
  'clearSelectedConversation';
export const CHAT_LIST_SET_PAGINATION_LOADING_STATUS_ACTION =
  'setPaginationLoadingStatus';
export const CHAT_LIST_BULK_CLEAR_SELECTION_ACTION =
  'bulkActions/clearSelectedConversationIds';
export const CHAT_LIST_BULK_EMAIL_BATCH_ARCHIVE_ACTION =
  'bulkEmailActions/batchArchive';
export const CHAT_LIST_BULK_EMAIL_BATCH_TRASH_ACTION =
  'bulkEmailActions/batchTrash';
export const CHAT_LIST_BULK_EMAIL_BATCH_MOVE_ACTION =
  'bulkEmailActions/batchMove';
export const CHAT_LIST_UPDATE_FILTERS_ACTION = 'updateChatListFilters';
export const CHAT_LIST_TOGGLE_STATUS_ACTION = 'toggleStatus';
export const CHAT_LIST_SET_UNREAD_FIRST_ACTION = 'setUnreadFirst';
export const CHAT_LIST_SET_PRIORITY_FILTER_ACTION = 'setPriorityFilter';
export const CHAT_LIST_SET_CONTEXT_MENU_CHAT_ID_ACTION = 'setContextMenuChatId';
export const CHAT_LIST_SET_CHAT_SORT_FILTER_ACTION = 'setChatSortFilter';
export const CHAT_LIST_CHAT_SORT_FILTER_GETTER = 'getChatSortFilter';
export const CHAT_LIST_SET_CHAT_LIST_FILTERS_ACTION = 'setChatListFilters';
export const CHAT_LIST_ASSIGN_MICROSOFT_FOLDERS_ACTION =
  'assignMicrosoftFolders';
export const CHAT_LIST_ASSIGN_IMAP_FOLDERS_ACTION = 'assignImapFolders';
export const CHAT_LIST_ASSIGN_GMAIL_LABELS_ACTION = 'assignGmailLabels';
export const CHAT_LIST_CURRENT_PAGE_FILTER_GETTER =
  'conversationPage/getCurrentPageFilter';
export const CHAT_LIST_BULK_SET_SELECTION_ACTION =
  'bulkActions/setSelectedConversationIds';
export const CHAT_LIST_BULK_REMOVE_SELECTION_ACTION =
  'bulkActions/removeSelectedConversationIds';
export const CHAT_LIST_BULK_PROCESS_ACTION = 'bulkActions/process';
export const CHAT_LIST_BULK_SELECTED_IDS_GETTER =
  'bulkActions/getSelectedConversationIds';
export const CHAT_LIST_SET_CONVERSATION_FILTERS_ACTION =
  'setConversationFilters';
export const CHAT_LIST_SET_CHAT_STATUS_FILTER_ACTION = 'setChatStatusFilter';
export const CHAT_LIST_SET_ACTIVE_INBOX_ACTION = 'setActiveInbox';
export const CHAT_LIST_MARK_MESSAGES_UNREAD_ACTION = 'markMessagesUnread';
export const CHAT_LIST_FETCH_FILTERED_ACTION = 'fetchFilteredConversations';
export const CHAT_LIST_FETCH_CACHED_ACTION = 'fetchCachedConversations';
export const CHAT_LIST_FETCH_ALL_ACTION = 'fetchAllConversations';
export const CHAT_LIST_CLOSE_CONVERSATION_ACTION = 'closeConversation';
export const CHAT_LIST_CLEAR_CONVERSATION_FILTERS_ACTION =
  'clearConversationFilters';
export const CHAT_LIST_TOGGLE_STARRED_ACTION = 'toggleStarred';
export const CHAT_LIST_ASSIGN_PRIORITY_ACTION = 'assignPriority';
export const CHAT_LIST_PREFETCH_MESSAGES_ACTION =
  'prefetchConversationMessages';
export const CHAT_LIST_REMOVE_RESOLVED_CONVERSATIONS_ACTION =
  'removeResolvedConversations';
export const CHAT_LIST_CONVERSATION_ASSIGNEE_ID_FIELD = 'assignee_id';
export const CHAT_LIST_CONVERSATION_META_ASSIGNEE_FIELD = 'assignee';
export const CHAT_LIST_CONVERSATION_LABELS_FIELD = 'labels';
export const CHAT_LIST_UPDATE_LAST_ACTIVITY_MUTATION =
  'UPDATE_CONVERSATION_LAST_ACTIVITY';
export const CHAT_LIST_SET_LOADING_STATUS_MUTATION = 'SET_LIST_LOADING_STATUS';

export const buildChatListRootListenerEntries = ({
  CONVERSATION_CARD_ROOT_EVENT_STATE_CHANGED,
  CONVERSATION_LIST_LABEL_LOADING_END_EVENT,
  CONVERSATION_LIST_LABEL_LOADING_START_EVENT,
  CONVERSATION_LIST_REMOVE_FROM_LIST_EVENT,
  CONVERSATION_LIST_SILENT_REFRESH_EVENT,
} = {}) => [
  [CONVERSATION_CARD_ROOT_EVENT_STATE_CHANGED, 'onConversationStateChanged'],
  [CONVERSATION_LIST_REMOVE_FROM_LIST_EVENT, 'removeConversationFromList'],
  [CONVERSATION_LIST_SILENT_REFRESH_EVENT, 'onSilentRefreshConversations'],
  [CONVERSATION_LIST_LABEL_LOADING_START_EVENT, 'onLabelLoadingStart'],
  [CONVERSATION_LIST_LABEL_LOADING_END_EVENT, 'onLabelLoadingEnd'],
];

export const buildChatListEmitterListenerEntries = ({
  CMD_SNOOZE_CONVERSATION,
} = {}) => [[CMD_SNOOZE_CONVERSATION, 'onCmdSnoozeConversation']];

export const applyChatListRootListenerEntries = ({
  component = null,
  entries = [],
  listener = null,
} = {}) => {
  if (!component || !Array.isArray(entries) || typeof listener !== 'function') {
    return false;
  }

  entries.forEach(([event, handler]) => {
    listener(event, component[handler]);
  });

  return true;
};

export const buildChatListEmitterListenerContext = ({
  component = null,
  emitter = null,
  mode = 'on',
} = {}) => {
  const resolvedEmitter = component?.$emitter || emitter;
  const emitterListener =
    resolvedEmitter && typeof resolvedEmitter[mode] === 'function'
      ? resolvedEmitter[mode].bind(resolvedEmitter)
      : null;

  return {
    listener:
      typeof emitterListener === 'function'
        ? (event, handler) => emitterListener(event, handler)
        : null,
  };
};

export const buildChatListEmitterEmitContext = ({
  component = null,
  emitter = null,
} = {}) => {
  const resolvedEmitter = component?.$emitter || emitter;
  const emit =
    resolvedEmitter && typeof resolvedEmitter.emit === 'function'
      ? resolvedEmitter.emit.bind(resolvedEmitter)
      : null;

  return {
    emit:
      typeof emit === 'function'
        ? (event, payload) => emit(event, payload)
        : () => null,
  };
};

export const buildChatListStoreActionContext = ({
  component = null,
  store = null,
} = {}) => {
  const resolvedStore = component?.$store || store;
  const getters = resolvedStore?.getters || {};
  const dispatch = resolvedStore?.dispatch;
  const commit = resolvedStore?.commit;

  return {
    callGetter: (getterName, payload, fallback = null) => {
      const getter = getters?.[getterName];
      return typeof getter === 'function' ? getter(payload) : fallback;
    },
    commit:
      typeof commit === 'function'
        ? (mutation, payload) => commit.call(resolvedStore, mutation, payload)
        : () => null,
    dispatch:
      typeof dispatch === 'function'
        ? (action, payload) => dispatch.call(resolvedStore, action, payload)
        : () => null,
    getGetterValue: (getterName, fallback = null) =>
      Object.prototype.hasOwnProperty.call(getters, getterName)
        ? getters[getterName]
        : fallback,
    hasDispatch: typeof dispatch === 'function',
  };
};

export const buildChatListChangeConversationStatusPayload = ({
  conversationId = null,
  status = null,
  snoozedUntil = null,
} = {}) => ({
  conversationId,
  status,
  snoozedUntil,
});
